import React from "react";
import Box from "../Box";
import { color } from "@sloth-system/styled-utils";
import styled from "styled-components/native";

interface RadioButtonType {
  selected: boolean;
}

function RadioButton(props: RadioButtonType) {
  let Border = styled(Box)`
    width: 20px;
    height: 20px;
    border-width: ${props.selected ? 1 : 2};
    border-color: ${color("primary.main")}
    border-style: solid;
    padding:2px;
`;
  return (
    <Border br="circle" bg="common.white">
      <Box
        bg={props.selected ? "primary.main" : "common.white"}
        br="circle"
        style={{ width: "100%", height: "100%" }}
      ></Box>
    </Border>
  );
}

export default RadioButton;
